import { render, staticRenderFns } from "./EditorInput.vue?vue&type=template&id=63682195&"
import script from "./EditorInput.vue?vue&type=script&lang=js&"
export * from "./EditorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports